<template>
    <NuxtLayout name="main" :class="css.container" :footer="false" :top="0">
        <!-- * 确认窗口 -->
        <confirm-modal ref="confirm" @confirm="methods.remove" :content="$t('ChatagentRemoveTips')" />
        <!-- * 收藏  -->
        <div class="container relative">
            <div class="absolute top-[36px] right-0">
                <Favorites />
            </div>
        </div>
        <!-- * 头部 -->
        <div :class="css.header">
            <h1 :class="css.name" class="container font-variable font-bold">RDDC AI Assistant</h1>
        </div>

        <!-- * 内容 -->
        <div :class="css.body">
            <!-- * 主内容区域 -->
            <div :class="css.main">
                <!-- * 名称 -->
                <div :class="[css.name, css.module]" v-if="name">
                    <div :class="css.content" class="ellipsis">{{ name }}</div>
                </div>

                <!-- * 信息 -->
                <div :class="css.infos">
                    <div :class="css.module">
                        <!-- * 内容 -->
                        <div :class="css.messages" ref="content">
                            <div :class="[css.message, css[value.msg_type]]" v-for="(value, key) in messages" :key="key">
                                <!-- * 机器人头像 -->
                                <div :class="css.robot" v-if="value.msg_type == 'answer' || value.msg_type == 'form'">
                                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/robot.webp" />
                                </div>

                                <!-- * 回复 -->
                                <div :class="css.content" v-loading="value.msg_code == 'readonly'">
                                    <template v-if="value.msg_code != 'readonly'">
                                        <!-- * 内容 -->
                                        <div v-html="value.message"></div>
                                        <!-- * 表单组件 -->
                                        <template v-if="value.msg_type == 'form'">
                                            <module-form :origin="value" :disabled="key != messages.length - 1" @submit="methods.submit" />
                                        </template>
                                        <!-- * 交互控件 -->
                                        <div :class="css.icons" v-if="value.msg_type == 'answer' && value.msg_code != 'connect'">
                                            <ui-icon :class="css.icon" name="copy" @click="methods.copy(value.message)" />
                                            <ui-icon :class="[css.icon, value.like && css.active]" name="support" @click="methods.like(value)" />
                                            <ui-icon
                                                :class="[css.icon, value.dislike && css.active]"
                                                name="nonsupport"
                                                @click="methods.dislike(value)" />
                                        </div>
                                    </template>
                                </div>

                                <!-- * 用户头像 -->
                                <template v-if="value.msg_type == 'ask'">
                                    <img
                                        :class="css.avaer"
                                        src="https://rdgta.cdn.cyagen.com/rddc/pictures/6bafaec1-95ed-4687-8489-6c79d48f0451.webp" />
                                </template>
                            </div>
                        </div>

                        <!-- * 侧边控制器 -->
                        <div :class="css.controls">
                            <div :class="css.control" @click="methods.create()">
                                <ui-icon :class="css.icon" name="conversation" />
                                <span>{{ $t("NewConversation") }}</span>
                            </div>

                            <div :class="css.control" @click="visible = !visible">
                                <ui-icon :class="css.icon" name="history" />
                                <span>{{ $t("HistoryConversation") }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div :class="css.footer">
                    <div :class="css.module">
                        <ui-icon :class="css.icon" name="send" v-show="!readonly" @click="methods.send" />
                        <ui-textarea :class="css.input" v-bind="binds.input" v-model="keyword" ref="textarea" @enter.prevent="methods.send" />
                    </div>
                </div>
            </div>

            <!-- * 侧边历史内容区域 -->
            <div :class="css.aside" v-show="visible">
                <div :class="css.module">
                    <div :class="css.title" class="font-variable font-bold color-1">{{ $t("HistoryConversation") }}</div>
                    <div :class="css.close" @click="visible = false">{{ $t("Close") }}</div>
                    <div :class="css.historys">
                        <template v-for="(value, key) in historys" :key="key">
                            <div :class="[css.history, id == value.id && css.active]" @click="methods.history(value)">
                                <div :class="css.content">
                                    <div :class="css.name" class="ellipsis">{{ value.name }}</div>
                                    <div :class="css.date" class="font-variable">{{ value.date }}</div>
                                </div>

                                <ui-icon :class="css.remove" name="ashcan" @click.stop="confirm?.open(value)" />
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库
import { $loading, UiIcon, UiTextarea } from "various-ui";
//* 公共组件
import { ConfirmModal } from "@/components/windows";
import { Favorites } from "@/components/controls";
//* 私有组件
import ModuleForm from "./components/form/index.vue";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";

//* 组合函数
const { vars, refs, nodes, binds, methods, computeds } = useComposable();
const { id, name, keyword, visible, messages, historys } = refs;
const { textarea, confirm, content } = nodes;
const { readonly } = computeds;

//* 组件挂载时连接会话
onMounted(() => methods.create());
onBeforeUnmount(() => {
    vars.timer && clearInterval(vars.timer);
    if (vars.socket) {
        vars.socket.close();
    }
});
</script>
